import { roundToNearestMinutes } from 'date-fns';

export const roundTime = (date: Date): Date => roundToNearestMinutes(date, { nearestTo: 30, roundingMethod: 'ceil' });
